export const key = {
  token: '@gabinete:token',
  refreshToken: '@gabinete:refreshToken',
  user: '@gabinete:user',
  permission: '@gabinete:permission',
  office: '@gabinete:office',
  role: '@gabinete:role',
  permissionsById: '@gabinete:permissionsById',
};
